
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import orderBy from "lodash/orderBy";

@Component
export default class MyTable extends Vue {
  @Prop(Array) readonly data!: any[];
  @Prop(Array) readonly columns!: any[];
  @Prop({ default: false }) readonly loading!: boolean;
  sortKey: string = "";
  isDes: boolean = true;
  sortArr: any[] = [];
  sortArrType: any[] = [];
  get sortType() {
    if (this.isDes) {
      return "desc";
    } else {
      return "asc";
    }
  }
  get showEmptyContent() {
    return this.data.length === 0 && !this.loading;
  }
  get sortedData() {
    return orderBy(this.data, this.sortArr, this.sortArrType);
  }
  sortBy(key: string) {
    this.sortKey = key || "";
    this.isDes = !this.isDes;
    if (key === "stakeChange") {
      this.sortArr = ["stakeChange", "holdingChange"];
    } else {
      this.sortArr = key ? [key] : [];
    }
    this.sortArrType = Array(this.sortArr.length).fill(this.sortType);
  }
}
